module.exports = __webpack_public_path__ + "assets/img/left.089efcc9.svg";